export default "__VITE_ASSET__K35PDmQr__"